import { render } from "./topDealer.vue?vue&type=template&id=54b97d22"
import script from "./topDealer.vue?vue&type=script&lang=js"
export * from "./topDealer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__